import { apiClient } from "@/lib/apiClient";
import type { CategoryGoodItem } from "@/lib/types/goods";

/**
 * Search goods by query within a specific storage.
 * @param storageId - Storage to search in
 * @param query - Search query (minimum 3 characters)
 * @returns Promise resolving to array of goods matching the query
 */
export async function fetchGoodsSearch(
    storageId: number,
    query: string
): Promise<CategoryGoodItem[]> {
    if (!query || query.length < 3) return [];
    const { data } = await apiClient.get("/api/v1/company/goods/search", {
        params: { storage_id: storageId, q: query }
    });
    // Expecting same structure as category goods items
    return Array.isArray(data?.items) ? data.items : [];
}
